import { render, staticRenderFns } from "./base-reward.vue?vue&type=template&id=aaea8dcc"
import script from "./base-reward.vue?vue&type=script&lang=js"
export * from "./base-reward.vue?vue&type=script&lang=js"
import style0 from "./base-reward.vue?vue&type=style&index=0&id=aaea8dcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports